import api from '@/apis/ba/baWithdrawAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('baWithdraw', api);

const state = {
  ...crud.state,
  _config: {
    table: 'ba_withdraw',
    field: {
      key: 'ref_id',
      code: 'ref_no',
      posted: 'is_posted',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Xóa nhiều
   * lttuan - 9.8.22
   */
  async customDelete(context, payload) {
    let res = null;
    payload = payload || {};
    try {
      context.commit('updateLoading', true);
      res = await api.customDelete(payload);
    } finally {
      context.commit('updateLoading', false);
    }

    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
